/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GenerateChallengeRequest } from '../models/GenerateChallengeRequest';
import type { GenerateChallengeResponse } from '../models/GenerateChallengeResponse';
import type { MobileAuthenticatedResponse } from '../models/MobileAuthenticatedResponse';
import type { SessionExchangeRequest } from '../models/SessionExchangeRequest';
import type { SessionExchangeResponse } from '../models/SessionExchangeResponse';
import type { ValidateSigningRequest } from '../models/ValidateSigningRequest';
import type { ValidateSigningResponse } from '../models/ValidateSigningResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileAuthService {
    /**
     * Generate authentication challenge (v2)
     * Generate a challenge for device authentication. Requires device to have a registered public key. Use with /validate-signing to complete auth.
     * @param requestBody
     * @returns GenerateChallengeResponse Successful Response
     * @throws ApiError
     */
    public static generateChallengeV2(
        requestBody: GenerateChallengeRequest,
    ): CancelablePromise<GenerateChallengeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mobile/v2/auth/generate-challenge',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
            },
        });
    }
    /**
     * Validate signed challenge and get access token (v2)
     * Validate a signed challenge. Signature is verified using the stored public key.
     * @param requestBody
     * @returns ValidateSigningResponse Successful Response
     * @throws ApiError
     */
    public static validateSigningV2(
        requestBody: ValidateSigningRequest,
    ): CancelablePromise<ValidateSigningResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mobile/v2/auth/validate-signing',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
            },
        });
    }
    /**
     * Exchange an idpToken for a mobile session
     * Redeem an auth-issued idpToken with a device proof verified by auth.
     * @param xDeviceProof
     * @param requestBody
     * @returns SessionExchangeResponse Successful Response
     * @throws ApiError
     */
    public static exchangeSession(
        xDeviceProof: string,
        requestBody: SessionExchangeRequest,
    ): CancelablePromise<SessionExchangeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mobile/v2/auth/session-exchange',
            headers: {
                'X-Device-Proof': xDeviceProof,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
            },
        });
    }
    /**
     * Check authentication status (v2)
     * Check if the current mobile session is authenticated.
     * @param xMobileAuth
     * @returns MobileAuthenticatedResponse Successful Response
     * @throws ApiError
     */
    public static checkAuthenticatedV2(
        xMobileAuth?: (string | null),
    ): CancelablePromise<MobileAuthenticatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mobile/v2/auth/authenticated',
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            errors: {
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
            },
        });
    }
}
